module.exports = __webpack_public_path__ + "static/media/操控交响乐队.763d515e.png";